import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const res = await login(email, password);
    setBusy(false);
    if (res.ok) { toast.success("Welkom terug"); navigate("/admin"); }
    else toast.error(res.error);
  };

  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-sfc-night px-5">
      <div className="pointer-events-none absolute -left-20 top-0 h-96 w-96 rounded-full bg-sfc-purple opacity-50 blur-[120px]" />
      <div className="pointer-events-none absolute -right-20 bottom-0 h-96 w-96 rounded-full bg-sfc-orange opacity-20 blur-[120px]" />
      <form data-testid="admin-login-form" onSubmit={submit} className="relative w-full max-w-sm rounded-3xl border border-white/10 bg-white/[0.04] p-8 backdrop-blur-xl">
        <div className="flex items-center gap-3">
          <img src="/soulfoodcity-logo.webp" alt="Soul Food City" className="h-12 w-12 rounded-full object-cover" />
          <div>
            <p className="font-display text-lg text-white">Beheerdersportaal</p>
            <p className="text-xs text-white/50">Soul Food City Drinks</p>
          </div>
        </div>
        <div className="mt-8 space-y-4">
          <input data-testid="login-email" required type="email" placeholder="E-mailadres" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full rounded-xl border border-white/10 bg-sfc-night px-4 py-3 text-sm text-white placeholder:text-white/40 focus:border-sfc-orange focus:outline-none" />
          <input data-testid="login-password" required type="password" placeholder="Wachtwoord" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full rounded-xl border border-white/10 bg-sfc-night px-4 py-3 text-sm text-white placeholder:text-white/40 focus:border-sfc-orange focus:outline-none" />
        </div>
        <button data-testid="login-submit" disabled={busy} className="mt-6 flex w-full items-center justify-center gap-2 rounded-full bg-gradient-to-r from-sfc-orange to-sfc-red px-6 py-3 text-sm font-semibold text-white disabled:opacity-60">
          {busy ? <Loader2 className="animate-spin" size={18} /> : <><Lock size={16} /> Inloggen</>}
        </button>
      </form>
    </div>
  );
}
